import { render } from "./ImpersonationBanner.vue?vue&type=template&id=1081a8df&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=1081a8df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081a8df"]])

export default __exports__